import { assertNever } from "@sa-nu/shared-utils/misc";

import {
  LOCALE_PREFIX_WITH_PATH_RE,
  parseLocale,
  type LocaleString,
} from "./settings";

/**
 * Prepend the URL prefix for `locale` to an absolute path.
 * - `ja`: no prefix (default language)
 * - `en`: `/en`
 * - `zh-CN`: `/zh-cn` (lower-case in URLs)
 * - `zh-TW`: `/zh-tw` (lower-case in URLs)
 *
 * Use from anywhere on the [locale] route tree that needs to navigate to
 * another i18n target page (router.push / redirect / Link href) so the
 * active locale survives the navigation.
 */
export function withLocalePrefix(path: string, locale: LocaleString): string {
  if (locale === "ja") return path;
  if (locale === "en") return `/en${path}`;
  if (locale === "zh-CN") return `/zh-cn${path}`;
  if (locale === "zh-TW") return `/zh-tw${path}`;
  assertNever(locale);
}

/** Extract the locale from a single path's prefix, or null if none. */
export function matchLocalePrefix(path: string): LocaleString | null {
  const match = path.match(LOCALE_PREFIX_WITH_PATH_RE);
  return match?.[1] ? parseLocale(match[1]) : null;
}
